import React from 'react';
import { Button } from '@mui/material';
import { commonButtonProps } from './commonButtonInterface';

const CancelButton: React.FC<commonButtonProps> = ({
  buttonText,
  onClick,
  sx = {},
  icon: IconComponent,
}) => (
  <Button
    sx={{
      borderRadius: {
        xxl: '0.5rem',
        xl: '0.5rem',
        lg: '0.438rem',
        md: '0.413rem',
      },
      color: '#2D3748',
      padding: { xl: '0.5rem 0.8rem !important', lg: '0.4rem 0.7rem' },
      fontSize: {
        xxl: '1.1rem',
        xl: '0.9rem',
        lg: '0.8rem',
        md: '0.7rem',
      },
      ...sx,
    }}
    onClick={onClick}
    startIcon={IconComponent && <IconComponent />}
  >
    {buttonText}
  </Button>
);

export default CancelButton;
